import { makeStyles } from '@mui/styles'
import { appTheme } from '../../theme'

// css style
export const useStyles = makeStyles({
  '@global': {
    '& .MuiFilledInput-root': {
      background: 'rgba(0, 0, 0, 0.2)'
    }
  },
  root: {
    height: 'calc(100vh - 72px)',
    width: 'flex',
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: ' rgba(0, 0, 0, 0.2)'
      },
      '&:hover fieldset': {
        borderColor: '#006BD7'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#006BD7'
      }
    }
  },

  accordian: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '2rem',
    marginLeft: '10px',
    [appTheme.breakpoints.down('xl')]: {
      gap: '16px',
      flexDirection: 'row',
      justifyContent: 'space-between'
    },
    [appTheme.breakpoints.down('md')]: {
      display: 'block'
    }
  },
  rightBlock: {
    width: '100%',
    float: 'right',
    [appTheme.breakpoints.down('lg')]: {
      marginTop: '1rem',
      marginBottom: '5rem'
    },
    [appTheme.breakpoints.down('md')]: {
      width: '100%'
    }
  },
  leftBlock: {
    width: '86%',
    float: 'left',
    paddingRight: '20px',
    [appTheme.breakpoints.down('xl')]: {
      width: '100%'
    }
  },
  approver: {
    borderRadius: '4px',
    marginTop: '1rem'
  }
})
